import { changeGallery } from "./product_gallery";

const $select = $("#product-select");
const $selectOption = $select.find("option:selected");
const selectOptionTarget = $selectOption.data("target");

if ($select.length) {
  selectOptionTarget.split("|").map(itemTarget => {
    if (itemTarget.length > 0) {
      const $item = $(`[data-target="${itemTarget}|"]`);
      if ($item[0].localName === "input") {
        $item.prop("checked", true).trigger("change");
      } else {
        $item.parent().val($item.val()).trigger("change");
      }
    }
  });
}

$(".option-select, .option-input").on("change", function() {
  let optionTarget = "";

  $(".option-select option:selected, .option-input:checked").each(function() {
    const $this = $(this);
    const dataTarget = $this.data("target");
    if (dataTarget) {
      optionTarget += dataTarget;
    }
  });

  const $optionToSelect = $select.find(`option[data-target="${optionTarget}"]`);
  const optionPrice = $optionToSelect.data("price");
  $select.val($optionToSelect.val());
  $(".product__details-inner .product__price").html(optionPrice);

  let color = $optionToSelect.data("target").split("option-1-")[1];
  changeGallery(color.split("|")[0], $(this).closest(".product__row").find(".target_gallery"));
  $select.trigger("change");
});



// WEBPACK FOOTER //
// ../assets/js/variants.js